import { BaseComponent } from '../../../components/BaseComponent';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
import { deleteWorkflow } from '../actions';
import { FormField } from '../../../components/FormFields';
import { updateWorkflowProduct } from './../actions';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import styles from './WorkflowProductEditModal.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  productId: null,
  quantity: null,
  price: null,
};

export class WorkflowProductEditModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.setState({
      productId: this.product?.productId,
      quantity: this.product?.quantity,
      price: this.price,
    });
  }

  get product() {
    return this.props.product;
  }

  get price() {
    return this.product?.price;
  }

  get oneTimePrice() {
    return this.product?.oneTimePrice;
  }

  onChangeQuantity(evt) {
    const quantity = +evt.target.value;
    const price = quantity ? quantity * +this.oneTimePrice : this.oneTimePrice;
    this.setState({ quantity, price });
  }

  onEdit() {
    this.props.updateWorkflowProduct({ quantity: this.state.quantity });
  }

  render() {
    return (
      <ModalComponent onClose={this.props.onClose}>
        <FormField label={this.lbl('workflows.productDetails.quantity')}>
          <>
            <input className="form-control" value={this.state.quantity} onChange={this.onChangeQuantity.bind(this)} />
            {!this.state.quantity && <RequireMark>*</RequireMark>}
          </>
        </FormField>
        <FormField label={this.lbl('product.create.sales_price')}>
          <input className="form-control" disabled value={this.state.price} onChange={() => {}} />
        </FormField>

        <div className={styles.buttonContainer}>
          <div className={styles.rowButtonsWrapper}>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.props.onClose}>
              {this.lbl('cancel')}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftEdit'} disabled={!this.state.quantity} onClick={this.onEdit.bind(this)}>
              {this.lbl('edit')}
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteWorkflow() {
      dispatch(deleteWorkflow(ownProps.workflow.id));
    },
    updateWorkflowProduct(dto) {
      dispatch(updateWorkflowProduct(ownProps.workflowId, ownProps.productId, dto));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowProductEditModal = compose(withConnect, withRouter)(WorkflowProductEditModalComp);
